import React from 'react';
import { SvgIcon } from "@material-ui/core";

export const BookmarkIcon = (props: any) => {
  return (
    <SvgIcon {...props} width="9" height="13" viewBox="0 0 9 13">
      <path fill="currentColor" d="M8.673 0H.32C.148 0 .008.14.008.313v11.703c0 .235.131.45.34.557.208.107.46.088.65-.049l3.499-2.508 3.5 2.509c.19.136.44.155.649.048.208-.108.34-.322.34-.557V.312C8.985.14 8.845 0 8.672 0z"/>
    </SvgIcon>
  );
};